module.exports = __webpack_public_path__ + "img/text.42965ffe.png";